export default "__VITE_ASSET__COiGLRcu__"